import en from "./en";
import fr from "./fr";
import pt from "./pt";

export { defaultNS, resources };

const defaultNS = "common";
const resources = {
  en,
  fr,
  pt,
} as const;
